import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { AppState } from '../reducers';
import { SessionCloseRequested } from '../session/store/session.actions';
import { idPersona, sessionOpen } from '../session/store/session.selectors';
import { IdPersonaSelectedChanged, MenuUsuarioInitRequested } from '../store/menu-usuario/menu-usuario.actions';
import { menuUsuarioAlreadyInitialized, menuUsuarioAportePlanSaludEnabled, menuUsuarioCapitaPacienteEnabled, menuUsuarioComprobanteTesoreriaEnabled, menuUsuarioOnInit } from '../store/menu-usuario/menu-usuario.selectors';

@Component({
	selector: 'menu-usuario',
	templateUrl: './menu-usuario.component.html',
	styleUrls: ['./menu-usuario.component.scss']
})
export class MenuUsuarioComponent implements OnDestroy {

	INFO_PERSONAL_ROUTE = "/perfil/informacion-personal";

	@Output()
	onOpenSugerencias = new EventEmitter();

	aportePlanSaludEnabled$: Observable<boolean>;
	comprobanteTesoreriaEnabled$: Observable<boolean>;
	capitaPacienteEnabled$: Observable<boolean>;
	private initSubscription: Subscription;


	constructor( private store: Store<AppState>, private router: Router ) {
		this.aportePlanSaludEnabled$ = this.store.select( menuUsuarioAportePlanSaludEnabled );
		this.comprobanteTesoreriaEnabled$ = this.store.select( menuUsuarioComprobanteTesoreriaEnabled );
		this.capitaPacienteEnabled$ = this.store.select( menuUsuarioCapitaPacienteEnabled );
		this.initSubscription = combineLatest( [ this.store.select( sessionOpen ), this.store.select( menuUsuarioOnInit ), this.store.select( menuUsuarioAlreadyInitialized ) ] )
			.pipe(
				filter( ([ open, onInit, alreadyInit ]) => open ),
				first(),
				tap( ([ open, onInit, alreadyInit ]) => {
					if( !onInit && !alreadyInit )
						this.store.dispatch( new MenuUsuarioInitRequested() );
				})
			).subscribe();
	}

	ngOnDestroy(): void {
		if( this.initSubscription )
			this.initSubscription.unsubscribe();
	}

	onCloseSession() {
		this.store.dispatch( new SessionCloseRequested() );
	}

	onMenuUsuarioClicked( route: string ) {
		this.store.select( idPersona ).pipe(
			first(),
			tap( ( idPersona ) => {
				this.store.dispatch( new IdPersonaSelectedChanged({ idPersona: idPersona }) );
				if( route === this.INFO_PERSONAL_ROUTE ) {
					// Esto es necesario por el buscador de personas
					this.router.navigate([ route, idPersona ]);
				} else {
					this.router.navigateByUrl( route );
				}
			})
		).subscribe();
	}

}
